import { Workspace } from '../../../../common/models/common-types';

export const findWorkspaces = (workspaces: Workspace[], searchInput: string): Workspace[] => {
    return workspaces.filter((ws) => ws.name.toLowerCase().includes(searchInput.toLowerCase()));
};
